// extracted by mini-css-extract-plugin
export default {"allActivitiesSection":"Activities_allActivitiesSection__Spe7L","total":"Activities_total__Y0YPw"};